import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  IconButton,
} from "@mui/material";
import no_data_found from "src/assets/images/no_data_found.png";
import CloseIcon from "@mui/icons-material/Close";
import { get_root_value } from "src/utils/domUtils";
import WorkoutExercisesHistoryUI from "../WorkoutExercisesHistoryUI";

function ExerciseHistoryModel({
  open,
  setOpen,
  data,
  handleChange,
  handleCopyExercise,
}) {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        fullScreen={window.innerWidth <= 550 ? true : false}
        maxWidth={"md"}
        fullWidth
        PaperProps={{
          style: {
            backgroundColor: "white",
            color: "black",
            boxShadow: "none",
          },
        }}
      >
        <div
          className={`text-end mt-1 d-flex justify-content-between align-items-center`}
        >
          <DialogTitle
            sx={{
              paddingY: 0,
              color: get_root_value("--portal-theme-primary"),
            }}
          >
            History
          </DialogTitle>

          <IconButton
            className="back-screen-button me-1 "
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {data && data.length == 0 ? (
              <div className="text-center">
                <img className="mx-auto" src={no_data_found} />
                <p className="mt-3 mx-auto">{`History Not Found`}</p>
              </div>
            ) : (
              <WorkoutExercisesHistoryUI
                addArray={data}
                setaddArray={handleChange}
                handleCopyExercise={handleCopyExercise}
              />
            )}
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default ExerciseHistoryModel;
